@let isWorkbenchMode = state.isMapInWorkbenchMode();

<div id="location-cards-widget">
  @if (isWorkbenchMode) {
    <div class="controls">
      <i
        [title]="'MAP-DISPLAY.BUTTONS.SETTINGS' | translate"
        class="icon icon-configure_settings"
        (click)="state.showLocationsWidgetConfigForm()"></i>
      <i
        [title]="'MAP-DISPLAY.BUTTONS.ADD-LOCATION' | translate"
        class="icon icon-add_plus_zoom-in"
        (click)="addLocation()"></i>
    </div>
  }

  @if (locations().length) {
    <div
      #cardContainer
      class="location-cards-container"
      [class.presentation-mode]="!isWorkbenchMode"
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)">
      @for (card of locationCards(); track card.location.uId) {
        <topo-location-card
          [id]="'location-card_' + card.location.uId"
          cdkDrag
          cdkDragBoundary=".locations-cards-container"
          [cdkDragDisabled]="card.location.uId !== selectedLocationUId()"
          [location]="card.location"
          [settings]="state.locationCardSettings()"
          [weatherInfo]="weatherConditions()[card.location.uId]"
          [canEdit]="isWorkbenchMode"
          [isSelected]="card.location.uId === selectedLocationUId()"
          (onClick)="setSelectedLocation(card.location.uId)"
          (onRemove)="removeLocation(card.location.uId)"
          (onNameChange)="changeLocationName(card.location.uId, $event)"
          (onSetLocationFromMap)="setLocationFromMap(card.location.uId)"
          [style.width]="cardWidth()"
          [style.left.%]="card.style.left"
          [style.z-index]="card.style.zIndex"
          [style.opacity]="card.style.opacity" />
      }
    </div>
  }
</div>
